import { useRef, useState } from "react";
// import emailjs from "emailjs-com";
import emailjs from "@emailjs/browser";

function Contact() {
  const formRef = useRef(null);
  const [status, setStatus] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    setStatus("Sending...");
    const form = formRef.current;
    emailjs
      .send(
        import.meta.env.VITE_EMAILJS_SERVICE_ID,
        import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
        {
          from_name: form.name.value,
          reply_to: form.email.value,
          message: form.message.value,
          to_email: "group118sai@gmail.com",
        },
        import.meta.env.VITE_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setStatus("Message sent! We'll get back to you shortly.");
        form.reset();
      })
      .catch(() => {
        setStatus("Something went wrong. Please try again later.");
      });
  }
  return (
    <div className="page contact">
      <section className="page-hero">
        <h1>Contact</h1>
        <p>Tell us about your project. We reply within 1 business day.</p>
      </section>

      <section className="section">
        <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
          <div className="grid">
            <label>
              Name
              <input name="name" type="text" placeholder="Your name" required />
            </label>
            <label>
              Email
              <input
                name="email"
                type="email"
                placeholder="you@example.com"
                required
              />
            </label>
          </div>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="What would you like to build?"
              required
            />
          </label>
          <button className="cta-btn" type="submit">
            Send Message
          </button>
          {status && <p className="form-status">{status}</p>}
        </form>
      </section>

      <section className="section">
        <h2>Our Office</h2>
        <address className="address">
          Vision Forte LLC
          <br />
          11218 Oudney Ct
          <br />
          Richmond, TX 77407
          <br />
          United States
        </address>
        <p>
          Email:{" "}
          <a href="mailto:group118sai@gmail.com">group118sai@gmail.com</a>
        </p>
        <div className="map-wrap">
          <div className="map-responsive">
            <iframe
              title="Vision Forte LLC Location"
              src="https://www.google.com/maps?q=11218%20Oudney%20Ct%2C%20Richmond%2C%20TX%2077407&output=embed"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <section className="section small">
        <p>
          Prefer email? Reach us at{" "}
          <a href="mailto:hello@visionforte.com">hello@visionforte.com</a>
        </p>
      </section>
    </div>
  );

  return <div></div>;
}

export default Contact;
